export const defaultRequestStatus = "To Do";

export const maxNumbersOfFiles = 4;
export const maxFileSize = 4 * 1024 * 1024;
export const minFileSize = 1024;
export const acceptableFileTypes =
    "audio/*,video/*,image/*,.pdf,.csv,.doc,.docx,.xml,.xls,.xlsx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
export const maxFileNameLength = 90;

export const companyCodeById: { [key: string]: string } = {
    AE10: "AE10 - Wartsila Gulf FZE",
    AE12: "AE12 - Wartsila Ships Repairing and Maintenance LLC",
    AE14: "AE14 - Wärtsilä L.L.C",
    AE17: "AE17 - Transas Middle East",
    AE18: "AE18 - Wärtsilä Energy and Offshore Services L.L.C - S.P.C",
    AR10: "AR10 - Wärtsilä Argentina  S.A.",
    AU10: "AU10 - Wärtsilä Australia Pty Lt",
    AU11: "AU11 - Wartsila Energy Storage Australia Pty Ltd",
    AZ11: "AZ11 - Wartsila Azerbaijan LLC",
    BD10: "BD10 - Wartsila Bangladesh Ltd",
    BF10: "BF10 - Wartsila Burkina Faso",
    BR10: "BR10 - Wartsila Brasil Ltda",
    CA11: "CA11 - Wärtsilä Canada Inc.",
    CA12: "CA12 - Wärtsilä PortLink",
    CH12: "CH12 - Wärtsilä Services Switzer",
    CL10: "CL10 - W Chile Ltda",
    CM10: "CM10 - Wärtsilä Central Africa",
    CN13: "CN13 - Wartsila Propulsion- Wuxi",
    CN15: "CN15 - Wärtsilä Shanghai Service",
    CN19: "CN19 - Wartsila Suzhou Ltd",
    CN20: "CN20 - Wartsila Management (Shanghai)",
    CN22: "CN22 - Wartsila SAM Electronics (Taizhou)",
    CN23: "CN23 - Transas Marine (Shanghai)",
    CN24: "CN24 - NACOS Marine Electronics (Shanghai) Ltd. Co.",
    CN25: "CN25 - NACOS Marine Trading (Suzhou) Ltd. Co.",
    CO10: "CO10 - W Colombia S.A.",
    CY11: "CY11 - Wärtsilä Cyprus Ltd.",
    CW10: "CW10 - Wärtsila Caribbean, Inc. - Curaçao Branch",
    DE10: "DE10 - Wärtsilä Deutschland GmbH",
    DE19: "DE19 - Wärtsilä SAM Electronics",
    DE25: "DE25 - Wärtsilä Voyage Germany GmbH",
    DE28: "DE28 - Wärtsilä Voyage GmbH",
    DK10: "DK10 - Wärtsilä Danmark A/S",
    DK14: "DK14 - Wärtsilä Lyngsø Marine A/",
    DO10: "DO10 - Wärtsilä Dominicana",
    EC10: "EC10 - Ecuador S.A.",
    EE10: "EE10 - Wärtsilä BLRT Estonia Oü",
    EG10: "EG10 - Wartsila Egypt Power",
    ES10: "ES10 - Wärtsilä Ibérica S.A.",
    ES17: "ES17 - Burriel Navarro S.L.",
    FI10: "FI10 - Wärtsilä Oyj Abp",
    FI11: "FI11 - Wärtsilä Technology Oy Ab",
    FI14: "FI14 - Wärtsilä Finland Oy",
    FI30: "FI30 - Wärtsilä Projects Oy",
    FI31: "FI31 - Wärtsilä Solutions Oy",
    FI34: "FI34 - Wärtsilä Voyage Oy",
    FI36: "FI36 - Wärtsilä Energy Storage Finland Oy",
    FR11: "FR11 - Wärtsilä France S.A.S.",
    FR17: "FR17 - Transas Mediterranean SAS",
    GA10: "GA10 - Wärtsilä CM, GABON",
    GB10: "GB10 - Wärtsilä UK Ltd.",
    GB37: "GB37 - Guidance Marine Ltd",
    GB42: "GB42 - Ships Electronic Services",
    GB43: "GB43 - Greenham Regis Ltd",
    GB44: "GB44 - Wartsila Defence Solution",
    GB46: "GB46 - Wartsila Energy Storage UK Ltd",
    GN10: "GN10 - Wärtsilä West Africa Guin",
    GR10: "GR10 - Wärtsilä Greece S.A",
    GY10: "GY10 - Wärtsilä Operations GY",
    HK10: "HK10 - Wärtsilä China Ltd",
    HU10: "HU10 - Wärtsilä Hungary Kft",
    ID10: "ID10 - PT. Wärtsilä Indonesia",
    IN10: "IN10 - Wärtsilä India",
    IT10: "IT10 - Wärtsilä Italia S.p.A",
    IT12: "IT12 - Wärtsilä APSS Srl",
    IT14: "IT14 - Trident Italia Srl",
    JP11: "JP11 - Wärtsilä Japan Ltd",
    KE10: "KE10 - Wärtsilä Eastern Africa",
    KR10: "KR10 - W Korea Ltd.",
    KR15: "KR15 - NACOS Korea Ltd. Co.",
    LK10: "LK10 - Wartsila Lanka (Pvt) Ltd",
    MM10: "MM10 - Wartsila Myanmar Company",
    MR11: "MR11 - Wartsila Mauritania",
    MR12: "MR12 - Wärtsilä Energy Mauritanie",
    MX11: "MX11 - Wärtsilä de Mexico S.A.",
    MY10: "MY10 - W Malaysia Sdn Bhd.",
    MZ10: "MZ10 - Wartsila Mozambique Ltd.",
    NG10: "NG10 - Wärtsilä M&P Nigeria",
    NL13: "NL13 - Wärtsilä Netherlands B.V.",
    NL27: "NL27 - QuantiParts B.V.",
    NL29: "NL29 - Trident BV",
    NL30: "NL30 - Transas Benelux B.V.",
    NL31: "NL31 - NACOS Marine Netherlands B.V.",
    NO10: "NO10 - Wärtsilä Norway A.S",
    NO15: "NO15 - Wärtsilä Moss AS",
    NO18: "NO18 - Wärtsilä Valmarine AS",
    OM10: "OM10 - Wartsila Muscat LLC",
    PA11: "PA11 - Wartsila Panama",
    PA12: "PA12 - Wärtsilä Panama Services",
    PE10: "PE10 - Wärtsilä Peru S.A.C.",
    PG10: "PG10 - Wartsila Papua New Guinea",
    PH10: "PH10 - Wärtsilä Philippines Inc",
    PK10: "PK10 - Wärtsilä Pakistan (Pvt.)",
    PL10: "PL10 - Wärtsilä Polska Sp.z.oo",
    PL15: "PL15 - Wärtsilä Global Business Services Poland Sp.Zoo",
    PR10: "PR10 - Wartsila Caribbean, Inc.",
    PT10: "PT10 - Wärtsilä Portugal, Lda.",
    QA10: "QA10 - Wärtsilä Doha LLC",
    RS11: "RS11 - Wärtsilä Voyage doo Beograd",
    RU12: "RU12 - Wärtsilä Vostok LLC",
    RU14: "RU14 - Wärtsilä Digital Technologies",
    RU15: "RU15 - Transas Navigator Ltd.",
    SA11: "SA11 - Wartsila Power Contractin",
    SE11: "SE11 - Wärtsilä Sweden AB",
    SE19: "SE19 - Transas Marine Int'l AB",
    SG10: "SG10 - W Singapore Pte Ltd",
    SG29: "SG29 - Wartsila Voyage Pacific P",
    SG30: "SG30 - Nacos Marine Singapore Pte Ltd",
    SN10: "SN10 - Wärtsilä West Africa",
    SV11: "SV11 - El Salvador",
    TR10: "TR10 - Wärtsilä-Enpa A.S.",
    TW10: "TW10 - Wartsila Taiwan Ltd",
    TZ10: "TZ10 - Wärtsilä Tanzania Ltd",
    UG10: "UG10 - Wartsila Uganda Limited",
    US13: "US13 - Wärtsilä North America In",
    US19: "US19 - Wärtsilä Dyn. Pos., Inc.",
    US20: "US20 - American Hydro Corp.",
    US25: "US25 - Lock-N-Stitch Inc.",
    US27: "US27 - Wartsila Energy Storage, Inc.",
    US28: "US28 - Nacos USA, Llc.",
    UY10: "UY10 - Wärtsilä Uruguay S.A.",
    UZ10: "UZ10 - Wartsila Samarkand Energy",
    VN11: "VN11 - Wärtsilä Vietnam Co Ltd",
    ZA10: "ZA10 - Wartsila Southern Africa (Pty) Ltd",
    ZA11: "ZA11 - Wartsila South Africa (Pty) Ltd",
    ZAE1: "ZAE1 - Wärtsilä Gulf FZE (Jordan)",
    ZEE1: "ZEE1 - Wärtsilä BLRT Estonia OÜ",
    ZFR2: "ZFR2 - Transas Mediterranean Sas",
    ZHU1: "ZHU1 - Wärtsilä Hungary Kft. Bud",
    ZID1: "ZID1 - Wärtsilä Indonesia Repres",
    ZIE1: "ZIE1 - Transas Greece",
    ZIE2: "ZIE2 - Transas India",
    ZIT1: "ZIT1 - Wartsila Italia MT Branch",
    ZKE1: "ZKE1 - Wärtsilä Eastern Africa L",
    ZPR1: "ZPR1 - Wartsila Caribbean, Inc (Bahamas)",
    ZUS1: "ZUS1 - Transas Argentina",
    ZUY1: "ZUY1 - Wartsila Uruguay SA Sucur",
    ZZA2: "ZZA2 - Wärtsilä ZA Madagascar",
    ZZA3: "ZZA3 - Wärtsilä ZA Zambia",
    XFI1: "XFI1 - Power Project Mexico S.A. de C.V",
    ZIE4: "ZIE4 - Wärtsilä Voyage QFZ Branch",
};

export const companyCodes = Object.keys(companyCodeById).map((id) => {
    return {
        label: companyCodeById[id],
        value: id,
    };
});
